import SocialIcons from './SocialIcons';

export { type SocialIconsProps, type SocialIconName } from './SocialIcons';
export default SocialIcons;
